export const ContactConst = {
  CHANNELURL: "channelurl",
  TELNO: "telno",
};
